import React from "react";

export default function RadioButtons({ label, questionId, answers, selectedAnswer, onChange }) {
    const describedById = `described-by-${questionId}`;


    const containsSentences = answers.some(answer => isProbablyASentence(answer.AnswerText));


    return (
        <div className="radio-group">
            <div className="question-label">{label}</div>
            <div {...{ className: containsSentences ? 'radio-wrap long-answers' : 'radio-wrap' }}>
            {
                answers.map(answer => {
                    const answered = !!selectedAnswer && answer.AnswerId === selectedAnswer;

                    return (
                        <RadioButton
                            key={answer.AnswerId}
                            name={questionId}
                            label={answer.AnswerText}
                            value={answer.AnswerId}
                            checked={answered}
                            describedById={describedById}
                            onChange={() => onChange(questionId, answer.AnswerId)}
                        />
                    );
                })
            }     
            </div>
        </div>
    );
}

function RadioButton(props) {
    const { name, label, value, checked, children } = props;

    const disabled = typeof props.disabled === 'boolean' ? props.disabled : false;

    const onChange = typeof props.onChange === 'function'
        ? (value) => props.onChange(value)
        : null;

    return (
        <label className="radio">
            <input type="radio"
                id={`radio-${value}`}
                name={name}
                value={value}
                disabled={disabled}
                checked={checked}
                onChange={(e) => onChange(e.target.value)}
            />
            {typeof label === 'string' ? label : children}


            {checked && (<Check />)}
        </label>
    );
}

function Check() {
    return <div className="radio-select">
        <svg
            aria-hidden="true"
            width={32}
            height={32}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0H24C28.4183 0 32 3.58172 32 8V32L16 16L0 0Z" fill="#9A5D31" />
        </svg>
        <svg
            aria-hidden="true"
            width={12}
            height={10}
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.86339 7.58312L1.08339 4.80312L0.136719 5.74312L3.86339 9.46979L11.8634 1.46979L10.9234 0.529785L3.86339 7.58312Z"
                fill="white"
            />
        </svg>
    </div>;
}

function isProbablyASentence(answer) {
    const charactersThatFitEasily = 12;
    const contains2orMoreSpace = text => /(\s.+){2,}/gi.test(text);

    return answer.length > charactersThatFitEasily && contains2orMoreSpace(answer);
}